/* stylelint-disable */
.main__links-area {
  display: block;
  box-sizing: border-box;
  border-top: 1px solid #e7e6e6;
}

.main__links-area *,
.main__links-area *::before,
.main__links-area *::after {
  box-sizing: inherit;
}

@media screen and (max-width: 979px) {
  .main__links-area {
    padding: 0 16px;
  }
}

.main__links-area .area__subsection {
  padding: 20px 0;
  display: block;
}

.main__links-area .area__subsection:not(.inline) > :not(:first-child) {
  margin-top: 20px;
}

.main__links-area .area__subsection:not(.inline) > :not(:last-child) {
  margin-bottom: 20px;
}

.main__links-area .area__subsection.inline {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
}

.main__links-area .area__subsection + .area__subsection {
  border-top: 1px solid #e7e6e6;
}

.offline-stores--delivery {
  margin-bottom: 8px;
  font-size: 0.875rem;
  line-height: 20px;
  color: #626469;
  text-transform: none;
  display: flex;
}

:host(:not([dir="rtl"])) .offline-stores--delivery {
  padding-left: 2px;
}

:host([dir="rtl"]) .offline-stores--delivery {
  padding-right: 2px;
}

.offline-stores--delivery-without-margin {
  margin: 0;
}

.offline-stores--delivery-time {
  margin: 0;
  padding-right: 4px;
  padding-left: 4px;
  font-weight: bold;
}

.offline-stores--tooltip {
  position: relative;
  top: 2px;
}

.offline-stores__link-wrapper {
  display: flex;
  align-items: center;
}

.qds-customized-multiline-standard-button {
  --qds-control-hero-border-radius: var(--qds-control-border-radius);
  --qds-control-hero-text: var(--qds-control-standard-text);
  --qds-control-hero-gap-internal: var(--qds-control-standard-gap-internal);
  --qds-control-hero-padding-auto-height: var(--qds-control-standard-padding-auto-height);
  --qds-control-button-hero-padding-horizontal: var(--qds-control-button-standard-padding-horizontal);
}

:host {
  display: block;
}

.cta_links {
  display: flex;
  flex-direction: row;
  gap: 24px;
}

@media screen and (max-width: 979px) {
  .cta_links {
    flex-direction: column;
    gap: 16px;
  }
}